import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-bl-apply-now-pc-v3.component.scss';
var FormItemBlApplyNowPcV3 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBlApplyNowPcV3, _super);
    function FormItemBlApplyNowPcV3(element) {
        return _super.call(this, element) || this;
    }
    FormItemBlApplyNowPcV3.prototype.init = function () {
    };
    FormItemBlApplyNowPcV3.prototype.bindEvents = function () {
    };
    FormItemBlApplyNowPcV3.prototype.updateForm = function (type) {
    };
    return FormItemBlApplyNowPcV3;
}(Base));
export { FormItemBlApplyNowPcV3 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-bl-apply-now-pc-v3/form-item-bl-apply-now-pc-v3.component.ts
// module id = 1028
// module chunks = 0